import { useEffect, useState } from "react";
import Api from "../../utils/Api";
import { API_ROUTE_E_RETAIL_ADVERTISER_EXCLUSIONS } from "../../routes";

export default function useBuyersAdPaid(auto = false) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [adExclusions, setAdExclusions] = useState([]);

  const getAdvertiserExclusions = () => {
    setIsLoading(true);

    Api.get(API_ROUTE_E_RETAIL_ADVERTISER_EXCLUSIONS)
      .then((response) => {
        const filtered = response.data.map((data) => data.value);
        setAdExclusions(filtered);
      })
      .catch((error) => {
        setError(error);
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (!auto) {
      return;
    }
    getAdvertiserExclusions();
  }, [auto]);

  return {
    isLoading,
    error,
    adExclusions,
    getAdvertiserExclusions,
  };
}
